// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"6d6d7d54","157":"c7ce4159","200":"0ff86ed0","360":"5732b877","426":"a45fba1f","471":"b0451f15","530":"0ef00c6e","551":"eefa1921","557":"9e623254","888":"b918416c","943":"4891d8a2"}[chunkId] + ".chunk.js";
};